import React, {useState} from 'react';
import LocationFinderProps from "./props";
import "./styles.scss";
import chevron_up from "../../../icons/chevron-up2.svg";
import chevron_down from "../../../icons/chevron-down2.svg";
import CurrentLocation from "../CurrentLocation/CurrentLocation";

import LocationSearchField from "./components/LocationSearchField";
import LocationRadius from "./components/LocationRadius";
import {definedValue} from "../../../utils/input";

function LocationFinder(props: LocationFinderProps) {
  const [isOpen, setIsOpen] = useState(props.isOpen ?? true);
  const {
    radiusOptions,
    radiusLabel,
    radiusDefaultText,
    radiusIndex,
    onChangeRadius,
    searchText,
    onChangeSearchField,
    isMobile,
    heading,
    currentLocationText,
    locationDeniedAlertText,
    onLocationChange,
    locationErrorText,
    searchOptions,
    handleClearSearch,
    handleSuggestionClick,
    searchPlaceholder,
    displaySuggestions,
    searchNotFoundText
  } = props;

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  }

  return (
    <div className={`location-finder ${isMobile ? 'mobile-filter' : ''}`}>
      <div className='location-finder__heading' onClick={toggleAccordion}>
        <h4>{heading}</h4>
        <img src={isOpen ? chevron_up : chevron_down} alt='location filter toggle icon' />
      </div>
      {isOpen && (
        <div className='location-finder__content'>
          <div className='location-finder__search-wrapper'>
            <LocationSearchField
              search={definedValue(searchText, '')}
              onChangeSearchField={onChangeSearchField}
              filterOptions={searchOptions}
              handleClear={handleClearSearch}
              handleSuggestionClick={handleSuggestionClick}
              searchPlaceholder={searchPlaceholder}
              searchNotFoundText={searchNotFoundText}
              displaySuggestions={displaySuggestions}
            />
            <CurrentLocation currentLocationText={currentLocationText} locationDeniedAlertText={locationDeniedAlertText} onLocationChange={onLocationChange} errorText={locationErrorText}/>
          </div>
          <LocationRadius
            options={radiusOptions}
            label={definedValue(radiusLabel, '')}
            selectedOption={definedValue(radiusDefaultText, '')}
            selectedIndex={definedValue(radiusIndex, 0)}
            handleOptionSelect={onChangeRadius}
          />
        </div>
      )}
    </div>
  );
}

export default React.memo(LocationFinder);